import {
    call, put, select, takeEvery,
} from 'redux-saga/effects';
import { message } from 'antd';
import { changeLeadStatus } from '../../requests/lead_manage_lead_status_request';
import { leadManageChangeLeadsStatusRequestSuccess, leadManageChangeLeadsStatusRequestFailure } from '../actions/lead_manage_lead_status.actions';
import { LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST } from '../constants/lead_manage_leads_status.constants';
import { getLeads, getLeadsCount } from '../../requests/get_leads_request';
import {
    countLeadsFailure, countLeadsSuccess, getLeadsFailure, getLeadsSuccess, setLeadManageLoading,
} from '../actions/get_leads.actions';

function* leadManageChangeLeadStatusRequest({ _id, status_id, requestParams }) {
    yield put(setLeadManageLoading(true));

    const changed_status = yield call(changeLeadStatus, _id, status_id, requestParams);

    if (changed_status.result) {
        const lead_manage_where = yield select((state) => state.Leads.Leads_manage.where);
        const lead_manage_pagination = yield select((state) => state.Leads.Leads_manage.pagination);

        if (lead_manage_where.ref_lead_customer === null || lead_manage_where.ref_bike_lead === null) {
            yield put(countLeadsSuccess(0));
            yield put(getLeadsSuccess([]));
        } else {
            const leads = yield call(getLeads, lead_manage_where, lead_manage_pagination);

            if (leads.result) {
                if (leads.options.length === 0) {
                    yield put(countLeadsSuccess(0));
                } else {
                    const leadsCount = yield call(getLeadsCount, lead_manage_where);

                    if (leadsCount.result) {
                        yield put(countLeadsSuccess(leadsCount.options.amount));
                    } else {
                        yield put(countLeadsFailure(leadsCount.error));
                    }
                }

                yield put(getLeadsSuccess(leads.options));
            } else {
                if (leads.error && leads.error.kind === 'number') {
                    message.error('Value must be number');
                } else {
                    message.error(leads.error.message);
                }
                yield put(countLeadsSuccess(0));
                yield put(getLeadsFailure(leads.error));
            }
        }

        yield put(leadManageChangeLeadsStatusRequestSuccess(changed_status.options));
        message.success('Lead status changed successfully!');
    } else {
        yield put(leadManageChangeLeadsStatusRequestFailure(changed_status.error));
        message.error('You cannot set this status!');
    }

    yield put(setLeadManageLoading(false));
}

export default function* leadManageChangeLeadStatusSaga() {
    yield takeEvery(LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST, leadManageChangeLeadStatusRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/change_lead_status.saga.js